// extracted by mini-css-extract-plugin
module.exports = {"container":"CarComparison_container__Y7VOd","title":"CarComparison_title__F6VL7","titleApp":"CarComparison_titleApp___cZCy","shimmer":"CarComparison_shimmer__Frq7l"};